export default "__VITE_ASSET__1f5bef5a__"